export const clientId = "k8Bj6XTiWOhrsmmrHHlpJiM4cWKzqclg" // Gets updated during jenkins release with value from jenkins
export const clientSecret = "ATOA3aQVpoWu4f2q6aEJ3t2VncdOd4Aso84aNn3_kF8WCLXbpVsmQvD380quuroGueIgBECC9107" // Gets updated during jenkins release with value from jenkins
export const cloudId = 'e4a17d36-bd48-4d69-aaa7-8b555336f9fc';

export const callback_url = window.location.origin
export const scope = "offline_access%20write%3Ajira-work%20manage%3Ajira-project%20read%3Ajira-user%20read%3Ajira-work%20manage%3Ajira-configuration"
